import React, { FC } from 'react'
import { t } from '@lingui/macro'
import IconEmptyResources from 'public/assets/img/empty-resources.svg'
import './ListEmpty.less'

interface IProps {
  title?: string
  description?: string
  showImage?: boolean
}

const ListEmpty: FC<IProps> = (props) => {
  const { title, description, showImage } = props

  return (
    <div className="ListEmpty">
      {(showImage === undefined || showImage) && (
        <img alt={t`Empty list`} src={IconEmptyResources} />
      )}
      {title && <h2>{props.title}</h2>}
      {description && <p>{props.description}</p>}
    </div>
  )
}

export default ListEmpty
